import { Table as TiptapTable } from '@tiptap/extension-table';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    setTableWidth: {
      setTableWidth: (fullWidth: boolean) => ReturnType;
    };
  }
}

export const Table = TiptapTable.extend({
  addAttributes() {
    return {
      fullWidth: {
        default: false,
      },
    };
  },
  addCommands() {
    return {
      ...this.parent?.(),
      setTableWidth:
        (fullWidth: boolean) =>
        ({ commands }) => {
          return commands.updateAttributes('table', { fullWidth: fullWidth });
        },
    };
  },
}).configure({ resizable: true });
